import React, { useCallback, useMemo } from 'react';
import { Comment } from 'components/items';
import CommentDefatul from './CommentDefatul';
import CommentReply from './CommentReply';

// CommentList.js

function CommentList({
  user,
  comment,
  //   clickHandler,
  handleRegist,
  handleReply,
  handleUpdate,
  handleDelete,
}) {
  return (
    <li>
      {comment && (comment.isReply || comment.isTemp) ? (
        <CommentReply
          user={user}
          comment={comment}
          handleRegist={handleRegist}
          handleReply={handleReply}
          handleUpdate={handleUpdate}
          handleDelete={handleDelete}
        />
      ) : (
        <CommentDefatul
          user={user}
          comment={comment}
          handleRegist={handleRegist}
          handleReply={handleReply}
          handleUpdate={handleUpdate}
          handleDelete={handleDelete}
        />
      )}
    </li>
  );
}

export default React.memo(CommentList);
